import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { t } from 'helpers/i18n'
import FormView from 'containers/Jobs/Forms/FormView'

export default createChildListViewComponent({
  entityName: entityNames.jobs,
  childName: 'formInstances',
  primaryLinkTarget: 'formInstanceRecord',
  createButtonTextId: 'addFormInstance',
  createButtonLinkTarget: {
    formSize: 'xl',
    formComponent: FormView,
  },
  createDisabled: (self) => (self.props.parentRecord?.id ?? 0) <= 0,
  getDeleteButtonTooltip: (self) => t('deleteFormsTooltip'),
})()
